var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.config.visible
    ? _c(
        "div",
        { staticClass: "modal-bg" },
        [
          _c(
            "AppDialog",
            {
              attrs: {
                title: "权限设置",
                "append-to-body": false,
                "custom-class": "amap-sug-result",
                width: "360px",
                loading: _vm.loading,
                height: "auto",
                top: _vm.top,
              },
              on: { success: _vm.sure },
              model: {
                value: _vm.config.visible,
                callback: function ($$v) {
                  _vm.$set(_vm.config, "visible", $$v)
                },
                expression: "config.visible",
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "rightsDialog",
                },
                [
                  _c(
                    "div",
                    { staticClass: "rightsList" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "rightsItem",
                          class: { active: _vm.active === 1 },
                          on: {
                            click: function ($event) {
                              _vm.active = 1
                            },
                          },
                        },
                        [
                          _vm.active !== 1
                            ? _c("img", {
                                staticClass: "rightsItemIcon",
                                attrs: {
                                  src: require("@/assets/image/aigc/lock.png"),
                                },
                              })
                            : _vm._e(),
                          _vm.active === 1
                            ? _c("img", {
                                staticClass: "rightsItemIcon",
                                attrs: {
                                  src: require("@/assets/image/aigc/lock_c.png"),
                                },
                              })
                            : _vm._e(),
                          _c("div", [_vm._v("私密·仅自己可对话")]),
                          _vm.active === 1
                            ? _c("img", {
                                staticClass: "checkIcon",
                                attrs: {
                                  src: require("@/assets/image/aigc/check.png"),
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "rightsItem",
                          class: { active: _vm.active === 2 },
                          on: {
                            click: function ($event) {
                              _vm.active = 2
                            },
                          },
                        },
                        [
                          _vm.active !== 2
                            ? _c("img", {
                                staticClass: "rightsItemIcon",
                                attrs: {
                                  src: require("@/assets/image/aigc/global.png"),
                                },
                              })
                            : _vm._e(),
                          _vm.active === 2
                            ? _c("img", {
                                staticClass: "rightsItemIcon",
                                attrs: {
                                  src: require("@/assets/image/aigc/global_c.png"),
                                },
                              })
                            : _vm._e(),
                          _c("div", [_vm._v("公开·所有人可对话")]),
                          _vm.active === 2
                            ? _c("img", {
                                staticClass: "checkIcon",
                                attrs: {
                                  src: require("@/assets/image/aigc/check.png"),
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-top": "24px", width: "100%" },
                          attrs: { loading: _vm.loading, type: "primary" },
                          on: { click: _vm.sure },
                        },
                        [_vm._v("确定")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }